import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_there_sufficient_emergency_exits_from_all_work_stations_and'

export const dataPointDefinition = {
  retracedId: 'are_there_sufficient_emergency_exits_from_all_work_stations_and',
  name: 'Are there sufficient emergency exits from all work stations and rest areas, and on every floor?',
  description:
    'Answer Yes if there are at least 2 possible exits from all work stations and rest areas (2 stairways in multi-story buildings); and the exits are located remotely from one another. Some occupancies or areas may allow for only one (1) exit, e.g. closed rooms (e.g., offices) can have one exit if the door opens onto an exit route. Codes and safety regulations may require additional exits. ',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-22-1x',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14820,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
